import { Button, ButtonTypes, isWeb } from 'fitbeat.react-native-components';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { SafeAreaView, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import FitillionIcon from '../assets/icons/fitillion.svg';
import { IAppStore } from '../HomeWorkouts';
import Theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';
import UserDataConsumer from '../utils/UserDataConsumer';
import { loadInvitationCodeSignupScreen, loadSignInScreen } from './actions';

interface IProps {
  t: any;
  signUp: () => void;
  signIn: () => void;
  loadScreen: () => void;
  isUserLoggedIn: boolean;
  invitedByUser: string;
}

class InvitationCodeSignup extends Component<IProps> {
  constructor(props) {
    super(props);
  }

  public componentDidMount = () => {
    this.props.loadScreen();
  }

  public render() {
    const { t } = this.props;

    return(
      <SafeAreaView style={styles.container}>
        <View style={styles.icon}>
          <FitillionIcon
            fill={Theme.BLACK}
            width={defaultScale(150)}
            height={defaultScale(150)}
          />
        </View>
        <View style={styles.contentContainer}>
            <View style={styles.textContainer}>
              <Text style={styles.text}>
                <Text style={{ ...Theme.textStyle.heading, fontFamily: Theme.Weight700, }}>
                  {this.props.invitedByUser}
                </Text>{' '}
                {t('familyPlan:invited')}.
              </Text>
            </View>
          </View>
          <Text onPress={this.props.signIn} style={styles.signIn}>
              {t('familyPlan:signIn')}
          </Text>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },
  contentContainer: {
    justifyContent: 'space-between',
    flex: 1,
    paddingHorizontal: defaultScale(15),
    marginTop: defaultScale(50),
  },
  icon: {
    marginTop: isWeb() ? defaultScale(20) : defaultScale(60),
    alignSelf: 'center',
  },
  textContainer: {
    marginTop: isWeb() ? defaultScale(30) : defaultScale(70),
  },
  text: {
    ...Theme.textStyle.heading,
    fontFamily: Theme.Weight400,
    textAlign: 'center',
    paddingTop: defaultScale(15),
  },
  signUpContainer: {
    marginBottom: defaultScale(20),
    marginTop: isWeb() ? defaultScale(40) : defaultScale(10),
  },
  joinContainer: {
    marginBottom: defaultScale(80),
    marginTop: defaultScale(10),
  },
  mainAction: {
    borderColor: Theme.PRIMARY,
    borderRadius: defaultScale(5),
    alignItems: 'center',
  },
  mainActionFontStyle: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
    color: Theme.WHITE,
  },
  signIn: {
    textAlign: 'center',
    color: Theme.PRIMARY,
    marginBottom: defaultScale(20),
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
  },
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    invitedByUser: state.deepLinkParamaters.referredByFullName,
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  const navigation = ownProps.navigation;

  return {
    signIn: () => dispatch(loadSignInScreen(navigation)),
    loadScreen: () => dispatch(loadInvitationCodeSignupScreen()),
  };
};

const invitationCodeSignupState = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(InvitationCodeSignup));
export default translate(['auth', 'familyPlan'], { wait: true })(invitationCodeSignupState);
